var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section-container',{staticClass:"wcyg--container"},[_c('h4',[_vm._v("With Centivo, you'll get:")]),_c('div',{staticClass:"content"},_vm._l((_vm.cardText),function(text,i){return _c('div',{key:i,staticClass:"content-card"},[_c('p',[_vm._v(_vm._s(text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }